import { Button } from '@fl/cmsch-fe-library';
import React, { FC, useCallback } from 'react';
interface Props {
  /** Other-subject-role binding identifier. */
  userProfileOtherSubjectRoleId: number;
  /** Callback invoked when the action is clicked. */
  onCellClick(userProfileOtherSubjectRoleId: number): void;
}

/**
 * Renders a clickable other-subject-management table action.
 *
 * @param props Cell identifier and click callback.
 * @returns Clickable other-subject-management table action.
 */
export const DynamicContent: FC<Props> = ({
  userProfileOtherSubjectRoleId,
  onCellClick
}) => {
  const handleCellClick = useCallback((): void => {
    onCellClick(userProfileOtherSubjectRoleId);
  }, [onCellClick, userProfileOtherSubjectRoleId]);
  return <Button icon="greenCheckCircleFilled" visuals="text" block onClick={handleCellClick} data-sentry-element="Button" data-sentry-component="DynamicContent" data-sentry-source-file="gen-dynamic-content.tsx" />;
};